// Globals
import { useTranslation } from 'react-i18next';

// Components
import { StyledTag } from '@/modules/Order';
import LogDiff from '../LogDiff/LogDiff';

// Models
import { Action, IBaseActionLog } from '@/models/logs.model';
import { StyledText } from './OrderActionStateStyles';

// Helpers
import { getCountDiff } from '../../helpers';

type TOrderActionStateProps = {
  log: IBaseActionLog;
};

export const OrderActionState = ({ log }: TOrderActionStateProps) => {
  const { t } = useTranslation(['common', 'logs']);
  switch (log.action) {
    case Action.ORDER_CREATED:
      return <StyledTag $status={log.action}>{t(`logs_status_${log.action}`, { ns: 'logs' })}</StyledTag>;
    case Action.ORDER_STATUS_UPDATED:
    case Action.ORDER_COMPLETED:
      return <LogDiff oldState={log?.diff?.old ?? {}} newState={log?.diff?.new ?? {}} />;
    default:
      return (
        <StyledText>
          {t(`logs_status_${log.action}`, {
            context: log.step_name,
            ns: 'logs',
            count: getCountDiff(log.diff?.old?.photos_count ?? 0, log.diff?.new?.photos_count ?? 0),
          })}
        </StyledText>
      );
  }
};
